const icon = require('vue-svgicon');
icon.register({
    'close': {
        width: 22,
        height: 22,
        viewBox: '0 0 22 22',
        data: `<path pid="0" d="M12.093 11l9.68 9.68a.772.772 0 11-1.092 1.093L11 12.093l-9.68 9.68a.772.772 0 11-1.094-1.092L9.908 11 .226 1.32A.772.772 0 111.32.227L11 9.907l9.68-9.68a.772.772 0 111.093 1.093L12.094 11z"/>`,
    },
});
